<template>
  <div class="clientDashboard">
    <Header />
    <div class="content">
      <router-view></router-view>
    </div>
   <!--  <Chat /> -->
    <Status />
  </div>
</template>

<script>
import { mapActions } from "vuex";
/* import Chat from "@/components/Chat.vue"; */
import Header from "@/components/HeaderClient.vue";
import Status from "@/components/Status.vue";

export default {
  name: "Dashboard",
  components: {
    /* Chat, */
    Header,
    Status,
  }, methods: {
    ...mapActions("user", ["CONF"]),
  },
  beforeMount() {
    this.CONF().then(r => {
      if (r && r.data && r.data.app_version) {

        let version = parseInt(r.data.app_version)
        let ov = localStorage.getItem("VERSION") || 0

        if (version > parseInt(ov)) {
          localStorage.setItem("VERSION", version)
          window.location.reload(true)
        }
      }
    })
  },
};
</script>

<style lang="sass">
@use "@/assets/scss/vars.scss" as *
.clientDashboard
  .config
    padding: 42px 35px
    @media (max-width: $small)
      padding: 7px
  *:required:invalid
    border-bottom: 3px solid $red
  input
    height: 50px
  select
    height: 57px
  input, select, textarea
    border-radius: 10px
    background: white
    padding: 0 9px
    @include border
    &:focus
        color: $purple
        font-weight: bold
  textarea
    padding: 12px
</style>
